import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

export const InsertFusionEntry = createAsyncThunk('InsertFusionEntry', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=insertFusioningEntry`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const InsertFusionReturnEntry = createAsyncThunk('InsertFusionReturnEntry', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=insertFusionReturnEntry`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

//action

export const fetchNumberMemoforFusion = createAsyncThunk('fetchNumberMemoforFusion', async (id) => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getNumberingMemoforFusioning&firmId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchFusionMemo = createAsyncThunk('fetchFusionMemo', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getFusionMemo`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


export const fetchFusiondata = createAsyncThunk('fetchFusiondata', async (id) => {
    try {
        const endpoint = id ? `getFusioningdata&fuId=${id}` : `getFusioningdata`;
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});



export const fetchFusionInwardlist = createAsyncThunk('fetchFusionInwardlist', async (id) => {
    try {
        const endpoint = id ? `getFusionInwardlist&fuId=${id}` : 'getFusionInwardlist';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

const fusioningApi = createSlice({
    name: 'FusioningDatalist',
    initialState: {
        isLoading: false,
        num: null,
        fmemo: null,
        fdata: null,
        finw: null,
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(fetchNumberMemoforFusion.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchNumberMemoforFusion.fulfilled, (state, action) => {
            state.isLoading = false;
            state.num = action.payload;
        });
        builder.addCase(fetchNumberMemoforFusion.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchFusionMemo.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchFusionMemo.fulfilled, (state, action) => {
            state.isLoading = false;
            state.fmemo = action.payload;
        });
        builder.addCase(fetchFusionMemo.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchFusiondata.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchFusiondata.fulfilled, (state, action) => {
            state.isLoading = false;
            state.fdata = action.payload;
        });
        builder.addCase(fetchFusiondata.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

         builder.addCase(fetchFusionInwardlist.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchFusionInwardlist.fulfilled, (state, action) => {
            state.isLoading = false;
            state.finw = action.payload;
        });
        builder.addCase(fetchFusionInwardlist.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });
    }
});

export default fusioningApi.reducer;
